import { DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
import { Dealer } from '../types/dealerTypes';
import { BackendService } from './BackendService';

export interface UpdateDealerRequest {
  dealerId: string;
  dealerUpdate: Partial<Dealer>;
}

export interface CreateLaunchPadDealerRequest {
  dealerId: string;
  dealerProps: Partial<Dealer>;
  dealerLogoFile?: string;
  userFirstName: string;
  userLastName: string;
  userEmail?: string;
}

export interface SetupLendingEnabledDealerRequest {
  dealerId: DealerId;
}

export class LaunchPadService {
  static createDealer(body: CreateLaunchPadDealerRequest) {
    return BackendService.post('/launchpad/dealers', body);
  }

  static getLaunchpadDealers() {
    return BackendService.get<Dealer[]>('/launchpad/dealers');
  }

  static sendPricingValidationEmail(dealerId: string) {
    return BackendService.post(
      `/launchpad/sendPricingValidationEmail/${dealerId}`,
    );
  }

  static sendWrongPricingText(
    dealerId: string,
    clientType: string, // instore, online
    wrongPricingValidationType: string, // new, used
    wrongPricingValidationFinanceType: string,
    wrongPricingValidationReasons: string[], // Vehicle wrong price, Wrong tax, etc.
    wrongPricingValidationText: string, // Dealer notes
    wrongPricingValidationStockNumber: string,
  ): Promise<any> {
    return BackendService.post(
      `/launchpad/wrongPricingValidation/${dealerId}`,
      {
        clientType,
        wrongPricingValidationType,
        wrongPricingValidationFinanceType,
        wrongPricingValidationReasons,
        wrongPricingValidationText,
        wrongPricingValidationStockNumber,
      },
    );
  }

  static setupLendingEnabledDealer(body: SetupLendingEnabledDealerRequest) {
    return BackendService.post('/launchpad/setupLendingEnabledDealer', body);
  }

  static updateDealerLending(body: SetupLendingEnabledDealerRequest) {
    return BackendService.put('/launchpad/updateDealerLending', body);
  }
}
